import React, { useState } from 'react';
import { Box, Typography, Button, useTheme, IconButton } from '@mui/material';
import { Sparkles, X } from 'lucide-react';
import { useAGTFitProContext } from '../context/AGTFitProContext';

const ProMessageAlert = ({ onGetPro }) => {
  const theme = useTheme();
  const { isPro } = useAGTFitProContext();
  const [isVisible, setIsVisible] = useState(true);

  // Si el usuario ya es PRO o si el componente está oculto, no mostrar la alerta
  if (isPro || !isVisible) return null;

  return (
    <Box
      sx={{
        padding: '12px 16px',
        borderRadius: '12px',
        background: theme.palette.mode === 'dark'
          ? 'linear-gradient(45deg, rgba(25,25,25,0.9) 0%, rgba(40,40,40,0.9) 100%)'
          : 'linear-gradient(45deg, rgba(245,245,245,0.9) 0%, rgba(250,250,250,0.9) 100%)',
        backdropFilter: 'blur(8px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        margin: '8px 0',
        border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
        position: 'relative', // Para posicionar el botón X correctamente
      }}
    >
      {/* Botón X para cerrar la alerta */}
      <IconButton 
        size="small" 
        onClick={() => setIsVisible(false)}
        sx={{
          position: 'absolute',
          top: '4px',
          right: '4px',
          padding: '4px',
          color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
          '&:hover': {
            color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.9)',
            background: 'transparent',
          }
        }}
      >
        <X size={16} />
      </IconButton>

      <Typography variant="body2" sx={{
        fontWeight: 500,
        textAlign: 'center',
        color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.9)',
      }}>
        ¿Necesitas un AGT más inteligente?
      </Typography>
     
      <Button
        startIcon={<Sparkles size={16} />}
        onClick={onGetPro}
        variant="contained"
        size="small"
        sx={{
          background: 'linear-gradient(90deg, #FF9800 0%, #FF6B00 100%)',
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: '8px',
          padding: '4px 12px',
          color: '#FFFFFF', // Texto blanco para ambos modos
          '&:hover': {
            background: 'linear-gradient(90deg, #FF8000 0%, #FF5500 100%)',
          }
        }}
      >
        Obtener AGT Fit Pro
      </Button>
    </Box>
  );
};

export default ProMessageAlert;